<div class="gamepass-interim">
  <div class="page-content">
    <!-- Top -->
    <div class="top-logo">
      <a href="https://www.producthunt.com/products/flinkit?utm_source=badge-top-post-badge&amp;utm_medium=badge#flinkit-friends" target="_blank" rel="noopener">
        <img
          src="https://api.producthunt.com/widgets/embed-image/v1/top-post-badge.svg?post_id=291287&amp;theme=light&amp;period=daily"
          alt="Flinkit Friends | Product Hunt"
        />
      </a>
    </div>

    <!-- Center -->
    <div class="center-content">
      <h2 class="title">{{ leftPanelCopy.title }}</h2>
      <p class="tagline">{{ leftPanelCopy.tagline }}</p>

      <div class="mode-selector">
        <div class="label">Game Mode:</div>
        <div class="fi-segmented-control gray">
          <button class="fi-text-bold" (click)="setGameMode('outdoor')" [class.active]="selectedGameMode === 'outdoor'">
            Outdoor
          </button>
          <button class="fi-text-bold" (click)="setGameMode('indoor')" [class.active]="selectedGameMode === 'indoor'">
            Indoor
          </button>
          <button class="fi-text-bold" (click)="setGameMode('event-hall')" [class.active]="selectedGameMode === 'event-hall'">
            Event Hall
          </button>
        </div>
      </div>

      <button class="flinkint-btn primary btn-block mt-3" (click)="startDemo()">
        Start demo
      </button>
    </div>

    <!-- Bottom -->
    <div class="bottom-partners">
      <div class="partners-title">Trusted by some of the best teams.</div>
      <div class="logos">
        <div class="logo-item" *ngFor="let logo of (virtualLogos | slice:0:3)">
          <img [src]="logo" alt="Partner Logo" />
        </div>
      </div>
    </div>
  </div>
</div>


